import { ProgressMeetingReportDto } from '@cradua/data';
import { createAction, props } from '@ngrx/store';

/**
 * Load Countries Collection Actions
 */
export const loadProgressMeeting = createAction(
  '[ProgressMeeting] Load ProgressMeeting'
);

export const loadProgressMeetingSuccess = createAction(
  '[ProgressMeeting] Load ProgressMeeting Success',
  props<{ progressMeeting: ProgressMeetingReportDto[] }>()
);

export const loadProgressMeetingFailure = createAction(
  '[ProgressMeeting] Load ProgressMeeting Failure',
  props<{ error: any }>()
);

/**
 * Add Project to Collection Actions
 */
export const addProgressMeeting = createAction(
  '[ProgressMeeting] Add ProgressMeeting',
  props<{ newProgressMeeting: ProgressMeetingReportDto[] }>()
);

export const addProgressMeetingSuccess = createAction(
  '[ProgressMeeting] Add ProgressMeeting Success',
  props<{ newProgressMeeting: ProgressMeetingReportDto[] }>()
);

export const addProgressMeetingFailure = createAction(
  '[ProgressMeeting] Add ProgressMeeting Failure',
  props<{ error: any }>()
);

/**
 * Search for record Collection Actions
 */
export const searchProgressMeetingRecord = createAction(
  '[ProgressMeeting] Search  ProgressMeeting Record',
  props<{ query: string }>()
);

/**
 * Update ProgressMeeting Collection Actions
 */
export const updateProgressMeeting = createAction(
  '[ProgressMeeting] Update ProgressMeeting',
  props<{ updateProgressMeeting: ProgressMeetingReportDto[] }>()
);

export const updateProgressMeetingSuccess = createAction(
  '[ProgressMeeting] Update ProgressMeeting Success',
  props<{ updateProgressMeeting: ProgressMeetingReportDto[] }>()
);

export const updateProgressMeetingFailure = createAction(
  '[ProgressMeeting] Update ProgressMeeting Failure',
  props<{ error: any }>()
);

/**
 * Remove ProgressMeeting Collection Actions
 */
export const removeProgressMeeting = createAction(
  '[ProgressMeeting] Remove ProgressMeeting',
  props<{ ids: string[] }>()
);

export const removeProgressMeetingSuccess = createAction(
  '[ProgressMeeting] Remove ProgressMeeting Success',
  props<{ ids: string[] }>()
);

export const removeProgressMeetingFailure = createAction(
  '[ProgressMeeting] Remove ProgressMeeting Failure',
  props<{ error: any }>()
);
